import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import { utils, read } from "xlsx";
import ReactFileReader from "react-file-reader";
import Pagination from "../../../components/Pagination";
import { unitConstModel } from "../../../constant/ConstantList";

import moment from "moment";

const StockUpload = (props) => {
  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  console.log("loginUserId", loginUserId);
  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);
  const [data, setData] = useState([]);
  const [unitList, setUnitList] = useState([]);

  const [wareHouseData, setWareHouseData] = useState([]);
  const [wareHouseId, setWareHouseId] = useState();
  const [productData, setProductData] = useState();

  const [formData, setFormData] = useState();

  const { sendRequest: getWarehouseData } = useHttp();

  const getWarehouseDetail = () => {
    getWarehouseData(
      {
        // url: "/api/warehouses/",
        url: `/api/warehouses/?orgId=${localStorage.getItem("orgId")}&&storeTypeId=1&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setWareHouseData(res);
        }
      }
    );
  };

  useEffect(() => {
    getWarehouseDetail();
  }, [getWarehouseData]);

  const { sendRequest: getUnit } = useHttp();

  const getUnitDetail = () => {
    getUnit(
      {
        url: `/api/units?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          ////console.log("units",res);
          var unit = res.filter(
            (item) =>
              item.unitTypeId == unitConstModel.NumberUnitTypeId ||
              item.unitTypeId == unitConstModel.weightUnitTypeId ||
              item.unitTypeId == unitConstModel.volumnUnitTypeId
          );
          //console.log(unit);
          setUnitList(unit);
        }
      }
    );
  };

  useEffect(() => {
    getUnitDetail();
  }, [getUnit]);

  const { sendRequest: getProductData } = useHttp();

  const FillDetail = () => {
    getProductData(
      {
        url: "/api/product/",
      },
      (res) => {
        if (res) {
          setProductData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getProductData]);

  const handleWarehouseChange = (e) => {
    setWareHouseId(e.target.value);
  };

  const handleFileRead = (e) => {
    const content = e.target.result;
    const workbook = read(content, { type: "binary" });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const parsedData = utils.sheet_to_json(worksheet, { header: 1 });
  
    const headers = parsedData[0];
    const validData = [];
    const jsonData = parsedData?.slice(1).map((row) => {
      const productName = row[headers.indexOf("Product Name")];

      const product =
        productData && productData.find((pro) => pro.productName == productName);
  
      const unitName = row[headers.indexOf("Unit")];
      const unit =
        unitList && unitList.find((unit) => unit.unitAbbreviation == unitName);
  
      // Check if product or unit is not found and show a toast message
      if (!product) {
        toast.error(`Product "${productName}" does not exist in the system.`);
        return null; // Skip this row
      }
  
      if (!unit) {
        toast.error(`Unit "${unitName}" does not exist in the system.`);
        return null; // Skip this row
      }
  
      // Create the stock object if product and unit both exist
      const stock = {
        productId: product ? product.productId : "",
        warehouseId: wareHouseId,
        serviceId: serviceId,
        productName: row[headers.indexOf("Product Name")],
        productSubType: row[headers.indexOf("Product SubType Name")],
        productType: row[headers.indexOf("Product Type Name")],
        quantity: row[headers.indexOf("Quantity")],
        unit: row[headers.indexOf("Unit")],
        unitId: unit ? unit.unitId : "",
        value: row[headers.indexOf("Value")],
        expiryDate: row[headers.indexOf("Expiry Date")],
        status: 1,
        createdBy: localStorage.getItem("id"),
        createdDate: moment().format("DD/MM/YYYY"),
        orgId: localStorage.getItem("orgId") || 2,
      };
  
      validData.push(row); 
      return stock;
    });
  
    // Filter out any rows that were skipped (i.e., null)
    const validStockData = jsonData.filter((row) => row !== null);
  
    console.log("jsonData", validStockData);
  
    setData(parsedData); // Set valid data for display in the table
    setFormData(validStockData); // Set valid data for submission
  };
  
  

  const handleFileUpload = (files) => {
    const file = files[0];
    const fileReader = new FileReader();
    fileReader.onloadend = handleFileRead;
    fileReader.readAsBinaryString(file);
  };
  const [itemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data&&data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: postStock } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();


  if (!formData || formData.length === 0) {
    toast.error("No valid stock data to submit.");
    return;
  }

    postStock(
      {
        url: "/api/openingStock/",
        method: "POST",
        body: formData,
      },
      (data) => {
        toast.success(`Stock Added  Successfully`);
        props.addForm(true);
        setFormData("");
        setData("");
        setWareHouseId("");
      }
    );
  };

  return (
    <>
      {" "}
      <div className="content-wrapper" style={{height:"0"}}>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <form onSubmit={submitHandler}>
                  <div className="card mt-2">
                    <div className="card-header">
                      <h3 className="card-title">Stock Details</h3>
                      <div className="card-tools">
                        <button
                          type="button"
                          className="btn btn-tool"
                          data-card-widget="remove"
                          onClick={() => props.addForm(false)}
                        >
                          <i className="fas fa-times" />
                        </button>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-3">
                          <label>Warehouse Name</label>
                          <select
                            className="form-control"
                            onChange={(e) => handleWarehouseChange(e)}
                          >
                            <option value="0"> Select Warehouse</option>

                            {wareHouseData &&
                              wareHouseData.map((x) => (
                                <option key={x.id} value={x.id}>
                                  {x.name}
                                </option>
                              ))}
                          </select>
                        </div>
                        <div className="col-3"></div>
                        {wareHouseId && (
                          <div className="col-2">
                            <ReactFileReader
                              handleFiles={handleFileUpload}
                              fileTypes={".xlsx"}
                            >
                              <button
                                type="button"
                                className="btn  btn-primary mx-2 my-2"
                              >
                                Upload Excel
                              </button>
                            </ReactFileReader>{" "}
                          </div>
                        )}
                      </div>
                      <hr />
                      <div className="row">
                        <table className="table table-bordered text-center table-sm">
                          <thead>
                            <tr className="tableheaderrowview">
                              {currentItems[0] &&
                                currentItems[0].map((header, index) => (
                                  <th key={index}>{header}</th>
                                ))}
                            </tr>
                          </thead>
                          <tbody>
                            {currentItems &&
                              currentItems.slice(1).map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                  {row.map((cell, cellIndex) => (
                                    <td key={cellIndex}>{cell}</td>
                                  ))}
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {/* /.card-body */}
                    <div className="card-footer clearfix">
                      <Pagination
                        totalItems={data.length}
                        itemsPerPage={itemsPerPage}
                        onPageChange={paginate}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                    </div>
                  </div>

                  <div className="text-center">
                    <button
                      className="btn  btn-primary mx-2 my-2"
                      type="submit"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default StockUpload;
